import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Ellipse } from "react-native-svg";

export const IconFormOval: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconFormOval"><Ellipse cx="11.75" cy="12" rx="9.5" ry="7.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
});

export default IconFormOval;
